<template>
  <section class="statistics-view">
    <div class="tab-container">
      <div class="tab-container__tabs">
        <router-link
          class="router-link"
          v-for="items in navigation.items"
          :key="items.title"
          :to="items.link"
        >
          <div class="tab-container__tabs__tab">
            <h2 class="h4">{{ items.title }}</h2>
          </div>
        </router-link>
      </div>
      <div class="tab-container__content">
        <transition name="component-fade" mode="out-in">
          <router-view />
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      navigation: {
        items: [
          {
            link: { name: "platform-statistics" },
            title: "guests",
            icon: "user",
          },
          {
            link: { name: "voucher-statistics" },
            title: "vouchers",
            icon: "dollar-sign",
          },
          {
            link: { name: "products-statistics" },
            title: "sales",
            icon: "dollar-sign",
          },
        ],
      },
    };
  },
};
</script>

<style scoped>
@media (max-width: 760px) {
  .statistics-view {
    flex-direction: column;
  }
}
</style>
